import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import moment from 'moment';
import getLocale from '../../../i18n/getLocale';

import FlightReportRefuelMultipleFieldsTab from './FlightReportRefuelMultipleFieldsTab';

class FlightReportRefuelRequestEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      load_flight_report_leg: false,
      flight_report_refuels: this.props.flight_report_refuels,
      flight_report_refuel_approvals: this.props.flight_report_refuels.flight_report_refuel_approvals,
      id: this.props.flight_report_refuel_request_edit.id,
      helitank_id: this.props.flight_report_refuel_request_edit.helitank_id,
      helitank_option: '',
      last_type: 'select',
      approval_required: 0,
      export_required: 0,
      aircraft_id: this.props.flight_report_refuel_request_edit.aircraft_id,
      aircraft_registration: this.props.flight_report_refuel_request_edit.aircraft_registration,
      date: this.props.flight_report_refuel_request_edit.date_str,
      flight_report_id: this.props.flight_report_refuel_request_edit.flight_report_id,
      flight_report_leg_id: this.props.flight_report_refuel_request_edit.flight_report_leg_id,
      maintenance_association: this.props.flight_report_refuel_request_edit.maintenance_association,
      extra_flight: this.props.flight_report_refuel_request_edit.extra_flight,
      internal_storage_tank: this.props.flight_report_refuel_request_edit.internal_storage_tank,
      fuel_supplier_id: this.props.flight_report_refuel_request_edit.fuel_supplier_id,
      refuel_reason_id: this.props.flight_report_refuel_request_edit.refuel_reason_id,
      location_id: this.props.flight_report_refuel_request_edit.location_id,
      requested: this.props.flight_report_refuel_request_edit.requested,
      comments: this.props.flight_report_refuel_request_edit.comments,
      company_id: this.props.flight_report_refuel_request_edit.company_id,
      address: this.props.flight_report_refuel_request_edit.address,
      staff_id: this.props.flight_report_refuel_request_edit.staff_id,
      next_location_id: this.props.flight_report_refuel_request_edit.next_location_id,
      water_check_before: this.props.flight_report_refuel_request_edit.water_check_before,
      water_check_during: this.props.flight_report_refuel_request_edit.water_check_during,
      water_check_after: this.props.flight_report_refuel_request_edit.water_check_after,
      base_id: this.props.flight_report_refuel_request_edit.base_id,
      remaining_fuel_quantity: this.props.flight_report_refuel_request_edit.remaining_fuel_quantity,
      required_fuel_for_next_flight: this.props.flight_report_refuel_request_edit.required_fuel_for_next_flight,
      required_fuel_in_liters: this.props.flight_report_refuel_request_edit.required_fuel_in_liters,
      fuel_per_tank: this.props.flight_report_refuel_request_edit.fuel_per_tank,
      fuel_type_id: this.props.flight_report_refuel_request_edit.fuel_type_id,
      flight_reports_select: this.props.flight_reports_select,
      flight_report_legs_select: this.props.flight_report_legs_select,
      flight_report_legs: this.props.flight_report_legs,
      fuel_suppliers_select: this.props.fuel_suppliers_select,
      refuel_reasons_select: this.props.refuel_reasons_select,
      aircrafts_select: this.props.aircrafts_select,
      helitank_select: this.props.helitank_select,
      locations_select: this.props.locations_select,
      companies_select: this.props.companies_select,
      staff_select: this.props.staff_select,
      fuel_types_select: this.props.fuel_types_select,
      bases_select: this.props.bases_select,
      fuel_unity: this.props.fuel_unity,
      user: this.props.user,
      water_check_select: [
        {value: 'Clear', label: 'Clear'},
        {value: 'Contaminated', label: 'Contaminated'},
      ],
    };

    this.edit = this.edit.bind(this);
    this.addRefuel = this.addRefuel.bind(this);
    this.handleChangeRefuelData = this.handleChangeRefuelData.bind(this);
    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleToggleExtraFlightChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      this.setState({
        helitank_id: this.props.flight_report_refuel_request_edit.helitank_id,
        helitank_option: '',
        last_type: 'select',
        internal_storage_tank: this.props.flight_report_refuel_request_edit.internal_storage_tank,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });

    } else {
      var value = 0;
      this.setState({
        helitank_id: '',
        helitank_option: '',
        last_type: 'select',
        internal_storage_tank: 0,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de internal storage, relatório de voo, trecho, localidade de destino e associação a voo de manutenção
    
  }
  handleToggleInternalStorageChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      this.setState({
        helitank_id: this.props.flight_report_refuel_request_edit.helitank_id,
        helitank_option: '',
        last_type: 'select',
        aircraft_id: null,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    } else {
      var value = 0;
      this.setState({
        helitank_id: '',
        helitank_option: '',
        last_type: 'select',
        aircraft_id: null,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de aeronave, relatório de voo, trecho, localidade de destino e associação a voo de manutenção

  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeReport(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');

      if(self.state.flight_report_legs[event.value]) {
        change['flight_report_legs_select'] = self.state.flight_report_legs[event.value];
      } else {
        change['flight_report_legs_select'] = [];
      }
      
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/basic/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.aircraft_id,
            fuel_type_id: responseJson.data.aircraft.aircraft_model.fuel_type_id,
            fuel_unity: responseJson.data.aircraft.aircraft_model.fuel_unity.abbreviation,
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.main.id,
            fuel_type_id: responseJson.data.main.aircraft_model.fuel_type_id,
            fuel_unity: responseJson.data.main.aircraft_model.fuel_unity.abbreviation,
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            locations_select: responseJson.data.locations_select,
            location_id: responseJson.data.flight_report_leg.departure_location_id,
            next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            approval_required: responseJson.data.main.refuel_approval_required,
            export_required: responseJson.data.main.refuel_export_required,
            auto_receit: responseJson.data.main.auto_receit,
            receit: responseJson.data.flight_report_refuel_data.receit,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleChangeRefuelData (name, value, index) {
    var flight_report_refuels = this.state.flight_report_refuels;
    flight_report_refuels[index][name] = value;
    this.setState({flight_report_refuels: flight_report_refuels});
  }

  changeLastInput(type) {
    this.setState({
      last_type: type,
    });
  }

  // LM
  componentWillReceiveProps(newProps) {
    var self = this;

    if((this.state.loaded === 0 && typeof newProps.flight_report_refuel_request_edit.id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
        this.setState({
            flight_report_refuels: newProps.flight_report_refuels,
            flight_report_refuel_approvals: newProps.flight_report_refuels.flight_report_refuel_approvals,
            id: newProps.flight_report_refuel_request_edit.id,
            aircraft_id: newProps.flight_report_refuel_request_edit.aircraft_id,
            helitank_id: newProps.flight_report_refuel_request_edit.helitank_id,
            aircraft_registration: newProps.flight_report_refuel_request_edit.aircraft_registration,
            date: newProps.flight_report_refuel_request_edit.date_str,
            flight_report_id: newProps.flight_report_refuel_request_edit.flight_report_id,
            flight_report_leg_id: newProps.flight_report_refuel_request_edit.flight_report_leg_id,
            maintenance_association: newProps.flight_report_refuel_request_edit.maintenance_association,
            extra_flight: newProps.flight_report_refuel_request_edit.extra_flight,
            receit: newProps.flight_report_refuel_request_edit.receit,
            auto_receit: newProps.flight_report_refuel_request_edit.auto_receit,
            internal_storage_tank: newProps.flight_report_refuel_request_edit.internal_storage_tank,
            fuel_supplier_id: newProps.flight_report_refuel_request_edit.fuel_supplier_id,
            refuel_reason_id: newProps.flight_report_refuel_request_edit.refuel_reason_id,
            location_id: newProps.flight_report_refuel_request_edit.location_id,
            requested: newProps.flight_report_refuel_request_edit.requested,
            comments: newProps.flight_report_refuel_request_edit.comments,
            company_id: newProps.flight_report_refuel_request_edit.company_id,
            address: newProps.flight_report_refuel_request_edit.address,
            staff_id: newProps.flight_report_refuel_request_edit.staff_id,
            next_location_id: newProps.flight_report_refuel_request_edit.next_location_id,
            water_check_before: newProps.flight_report_refuel_request_edit.water_check_before,
            water_check_during: newProps.flight_report_refuel_request_edit.water_check_during,
            water_check_after: newProps.flight_report_refuel_request_edit.water_check_after,
            base_id: newProps.flight_report_refuel_request_edit.base_id,
            remaining_fuel_quantity: newProps.flight_report_refuel_request_edit.remaining_fuel_quantity,
            required_fuel_for_next_flight: newProps.flight_report_refuel_request_edit.required_fuel_for_next_flight,
            required_fuel_in_liters: newProps.flight_report_refuel_request_edit.required_fuel_in_liters,
            fuel_per_tank: newProps.flight_report_refuel_request_edit.fuel_per_tank,
            fuel_type_id: newProps.flight_report_refuel_request_edit.fuel_type_id,
            fuel_unity: newProps.fuel_unity,
            flight_report_legs_select: newProps.flight_report_legs_select,
            flight_report_legs: newProps.flight_report_legs,
            flight_reports_select: newProps.flight_reports_select,
            fuel_suppliers_select: newProps.fuel_suppliers_select,
            refuel_reasons_select: newProps.refuel_reasons_select,
            aircrafts_select: newProps.aircrafts_select,
            helitank_select: newProps.helitank_select,
            locations_select: newProps.locations_select,
            companies_select: newProps.companies_select,
            staff_select: newProps.staff_select,
            fuel_types_select: newProps.fuel_types_select,
            bases_select: newProps.bases_select,
            user: newProps.user,
            loaded: 1,
        });
        if (typeof newProps.flight_report_refuel_request_edit.flight_report_id !== 'undefined') {
          // Atualiza os dados do relatório
          var change = {};
          var flight_report_id = newProps.flight_report_refuel_request_edit.flight_report_id;
          if(newProps.flight_report_legs[flight_report_id]) {
              change['flight_report_legs_select'] = newProps.flight_report_legs[flight_report_id];
          } else {
              change['flight_report_legs_select'] = [];
          }
          self.setState(change);
        }
      }

      if (typeof newProps.flight_report_refuel_request_edit.fuel_supplier_id !== 'undefined' && this.state.loaded === 1 && this.state.load_fuel_supplier !== 1) {
        //Atualiza os dados do fornecedor de combustível
        var header = this.refs.request_api.header('application/json');
        var fuel_supplier_id = newProps.flight_report_refuel_request_edit.fuel_supplier_id;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/fornecedor/combustivel/'+ fuel_supplier_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              load_fuel_supplier: 1,
            });
          });
        });
      }

      if (typeof newProps.flight_report_refuel_request_edit.flight_report_leg_id !== 'undefined' && this.state.loaded === 1 && this.state.load_flight_report_leg !== 1) {
        // Atualiza os dados do trecho
        var header = this.refs.request_api.header('application/json');
        var flight_report_leg_id = newProps.flight_report_refuel_request_edit.flight_report_leg_id;
        if (flight_report_leg_id >= 1) {
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+ flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.setState({
                locations_select: responseJson.data.locations_select,
                load_flight_report_leg: 1,
              });
            });
          });
        }
      }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    // var datasave = new FormData();
    // var imagedata = document.querySelector(".input-nf-file").files[0];
    // datasave.append("file", imagedata);
    var datasave = {
      helitank_id: this.state.helitank_id,
      helitank_option: this.state.helitank_option,
      last_type: this.state.last_type,
      id: this.state.id,
      aircraft_id: this.state.aircraft_id,
      date: this.state.date,
      flight_report_id: this.state.flight_report_id,
      flight_report_leg_id: this.state.flight_report_leg_id,
      maintenance_association: this.state.maintenance_association,
      extra_flight: this.state.extra_flight,
      internal_storage_tank: this.state.internal_storage_tank,
      fuel_supplier_id: this.state.fuel_supplier_id,
      refuel_reason_id: this.state.refuel_reason_id,
      location_id: this.state.location_id,
      requested: this.state.requested,
      comments: this.state.comments,
      company_id: this.state.company_id,
      address: this.state.address,
      staff_id: this.state.staff_id,
      next_location_id: this.state.next_location_id,
      water_check_before: this.state.water_check_before,
      water_check_during: this.state.water_check_during,
      water_check_after: this.state.water_check_after,
      base_id: this.state.base_id,
      remaining_fuel_quantity: this.state.remaining_fuel_quantity,
      required_fuel_for_next_flight: this.state.required_fuel_for_next_flight,
      required_fuel_in_liters: this.state.required_fuel_in_liters,
      fuel_per_tank: this.state.fuel_per_tank,
      fuel_type_id: this.state.fuel_type_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/solicitacao/abastecimento/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); self.props.handleAlert(error.message, error.status, 'open');}).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.updateData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;

    this.setState(change);
  }

  formFields(fields_type) {

    var fields = [];

    if (fields_type == 0) {
      fields.push(
        <div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Motivo}:</label>
              <Select
                className="form-field-name"
                name="refuel_reason_id"
                value={this.state.refuel_reason_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
                options={this.state.refuel_reasons_select}
                required
              />
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado} ({this.state.fuel_unity}):</label>
                <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"}  className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <label>Comments</label>
              <textarea style={{ height: 100 }} type="text" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
            </div>
          </div>
        </div>
      );
    } else {
      fields.push(
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Motivo}:</label>
              <Select
                className="form-field-name"
                name="refuel_reason_id"
                value={this.state.refuel_reason_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
                options={this.state.refuel_reasons_select}
                required
              />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado} ({this.state.fuel_unity}):</label>
                <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"}  className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required />
            </div>
            {(this.state.extra_flight == 0) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comandante}</label>
                  <Select
                    className="form-field-name"
                    name="staff_id"
                    value={this.state.staff_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'staff_id')}
                    options={this.state.staff_select}
                  />
              </div>
            }
          </div>

          <div className="row">
            {(this.state.extra_flight == 0) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ProximaLocalidade}:</label>
                  <Select
                    className="form-field-name"
                    name="next_location_id"
                    value={this.state.next_location_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                    options={this.state.locations_select}
                  />
              </div>
            }
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                  disabled={this.state.internal_storage_tank == 0 ? true : false}
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaAntes}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_before"
                  value={this.state.water_check_before}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_before')}
                  options={this.state.water_check_select}
                  required
                />
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaDurante}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_during"
                  value={this.state.water_check_during}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_during')}
                  options={this.state.water_check_select}
                  required
                />
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaDepois}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_after"
                  value={this.state.water_check_after}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_after')}
                  options={this.state.water_check_select}
                  required
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <label>Comments</label>
              <textarea style={{ height: 100 }} type="text" name="comments" className="form-control" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} />
            </div>
          </div>

        </div>
      );
    }

    fields.push(
      <div>

        {(this.state.internal_storage_tank == 0) &&
          <div>
            <div className="clearfix"></div>
            <hr/>
          
            <div className="row">
              <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelRemanescente} ({this.state.fuel_unity}):</label>
                <InputMask value={this.state.remaining_fuel_quantity} maskChar={null} name="remaining_fuel_quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'remaining_fuel_quantity')} placeholder="" />
              </div>
              {(this.state.required_fuel_for_next_flight !== null) &&
                <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelNecessario} ({this.state.fuel_unity}):</label>
                  <input value={this.state.required_fuel_for_next_flight} name="required_fuel_for_next_flight" className="form-control" onChange={this.handleChange.bind(this, 'required_fuel_for_next_flight')} placeholder="" disabled />
                </div>
              }
              {(this.state.required_fuel_in_liters !== null) &&
                <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelNecessarioLitros}:</label>
                  <input value={this.state.required_fuel_in_liters} name="required_fuel_in_liters" className="form-control" onChange={this.handleChange.bind(this, 'required_fuel_in_liters')} placeholder="" disabled />
                </div>
              }
              {(this.state.fuel_per_tank !== null) &&
                <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelPorTanque}:</label>
                  <input value={this.state.fuel_per_tank} name="fuel_per_tank" className="form-control" onChange={this.handleChange.bind(this, 'fuel_per_tank')} placeholder="" disabled />
                </div>
              }
            </div>
          </div>
        }

        <div className="row">
          <div className="col-md-12 form-group">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.botaoEditarSolicitacao}</button>
          </div>
        </div>

        <div className="clearfix"></div>
        <hr />
        <h4 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Abastecimentos}</h4>
        <button type="button" className="btn button-inline btn-warning pull-right" onClick={() => this.addRefuel()}><i className="fa fa-plus"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.botaoAdicionarAbastecimento}</button>
        <div className="clearfix"></div>
        <hr />

        {this.multipleRefuelsForm(fields_type)}
      </div>
    );

    return fields;

  }

  multipleRefuelsForm(fields_type) {

    var self = this;
    var fields = '';

    fields = (
      <div className="table-responsive">
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            {(fields_type == 0) &&
              <tr>
                <th hidden={true} className="text-center" style={{minWidth: '60px'}}>#</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Data}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDaCe}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelAbastecido}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comentarios}</th>
                <th className="text-center" style={{minWidth: '200px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Acoes}</th>
              </tr>
            }
            {(fields_type == 1) &&
              <tr>
                <th hidden={true} className="text-center" style={{minWidth: '150px'}}>#</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Data}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraInicial}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.InicioAbastecimento}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TerminoAbastecimento}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraFinal}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Entregues}</th>
                <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NotaFiscal}</th>
                {/* <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroCaminhao}</th> */}
                {/* <th className="text-center" style={{minWidth: '150px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TipoCombustivel}</th> */}
                <th className="text-center" style={{minWidth: '200px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comentarios}</th>
                <th className="text-center" style={{minWidth: '200px'}}>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Acoes}</th>
              </tr>
            }
          </thead>
          <tbody id="multiple-refuels-add">
            {(typeof self.state.flight_report_refuels !== 'undefined' && self.state.flight_report_refuels !== null) && self.state.flight_report_refuels.map(function(refuel, index) {
              return <FlightReportRefuelMultipleFieldsTab handleAlert={self.props.handleAlert} refuel_index={index} fields_type={fields_type} data={refuel} request_data={self.props.flight_report_refuel_request_edit} deleteRefuel={self.props.deleteRefuel} handleChangeRefuelData={self.handleChangeRefuelData} fuel_types_select={self.state.fuel_types_select} last_type={self.state.last_type} updateData={self.props.updateData} updated={self.props.updated} user={self.props.user} />
            })}
          </tbody>
        </table>
      </div>
    );

    return fields;

  }

  addRefuel() {
    if (this.state.export_required == 1) {
      //Verifico se os campos "water_check" estão preenchidos, do contrário, não deixo adicionar um novo abastecimento
      if (this.state.water_check_before == null || this.state.water_check_during == null || this.state.water_check_after == null) {
        this.props.handleAlert(this.locale.RelatorioAbastecimento.EditarAbastecimento.ChecagemAgua, 'error','open');
        return false;
      }
    }

    //Verifico se o campo de combustível remanescente está preenchido, do contrário, não deixo adicionar um novo abastecimento
    if (this.state.internal_storage_tank == 0 && this.state.required_fuel_in_liters == null) {
      this.props.handleAlert(this.locale.RelatorioAbastecimento.EditarAbastecimento.ChecagemCombustivelRemanescente, 'error','open');
      return false;
    }

    var flight_report_refuels = this.state.flight_report_refuels;

    if(this.state.auto_receit == 1) {
      var receit = this.state.receit + 1;
      this.setState({receit: receit});
    } else {
      var receit = null;
    }
    
    flight_report_refuels.push({
      date: moment().format('DD/MM/YYYY'),
      maintenance_association: this.state.maintenance_association,
      extra_flight: this.state.extra_flight,
      internal_storage_tank: this.state.internal_storage_tank,
      receit: receit,
      comments: this.state.comments,
      auto_receit: this.state.auto_receit,
      quantity: null,
      fueling_started: null,
      fueling_finished: null,
      reading_start: null,
      reading_finish: null,
      fuel_type_id: this.state.fuel_type_id,
    });
    
    this.setState({flight_report_refuels: flight_report_refuels});
  }

  changeLastInput(type) {
    this.setState({
      last_type: type,
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.dados}</h3>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.edit}>
    <div className="row">
      <div className="col-md-2 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Data}:</label>
        <InputMask value={this.state.date} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.general.diaMesAno} required />
      </div>
      <div className="col-md-2 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Fornecedor}:</label>
        <Select
          className="form-field-name"
          name="fuel_supplier_id"
          value={this.state.fuel_supplier_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
          options={this.state.fuel_suppliers_select}
          required
        />
      </div>
      <div className="col-md-2 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Empresa}:</label>
        <Select
          className="form-field-name"
          name="company_id"
          value={this.state.company_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChangeCompany.bind(this, 'company_id')}
          options={this.state.companies_select}
          required
          />
      </div>
      <div className="col-md-2 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Base}:</label>
        <Select
          className="form-field-name"
          name="base_id"
          value={this.state.base_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChange.bind(this, 'base_id')}
          options={this.state.bases_select}
          required
          />
      </div>
      <div className="col-md-2 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AbastecimentoExtraVoo}?</label>
        <br/>
        <Toggle
          checked={this.state.extra_flight}
          name="extra_flight"
          onChange={this.handleToggleExtraFlightChange.bind(this, 'extra_flight')}
          />
      </div>
      {(this.state.extra_flight === 1) &&
        <div className="col-md-2 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TanqueArmazenamentoInterno}?</label>
          <br/>
          <Toggle
            checked={this.state.internal_storage_tank}
            name="internal_storage_tank"
            onChange={this.handleToggleInternalStorageChange.bind(this, 'internal_storage_tank')}
          />
        </div>
      }
    </div>
    <div className="row">
      {(this.state.internal_storage_tank === 1) && (
            self.state.last_type === 'input' ?
              <div className="col-md-6 form-group">
                <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                <br/>
                <input type="text" name="helitank_option" className="form-control" placeholder="" value={this.state.helitank_option} onChange={this.handleChange.bind(this, 'helitank_option')} required />
              </div>
            : 
              <div className="col-md-6 form-group">
                  <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                    <br/>
                    <Select
                      className="form-field-name"
                      name="helitank_id"
                      value={this.state.helitank_id}
                      onChange={this.handleSelectChange.bind(this, 'helitank_id')}
                      options={this.state.helitank_select}
                      placeholder={'Selecione'}
                    />
              </div>
      )}
      {(this.state.extra_flight === 1) ?
            <div>
              {(this.state.internal_storage_tank === 0) &&
                <div className="col-md-4 form-group">
                    <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Aeronave}:</label>
                    <Select
                        className="form-field-name"
                        name="aircraft_id"
                        value={this.state.aircraft_id}
                        searchable={true}
                        placeholder={this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.placeholder.SelecioneAeronave}
                        onChange={this.handleSelectChangeAircraft.bind(this, 'aircraft_id')}
                        options={this.state.aircrafts_select}
                        required
                    />
                </div>
              }
              <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade}:</label>
                  <Select
                    className="form-field-name"
                    name="location_id"
                    value={this.state.location_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'location_id')}
                    options={this.state.locations_select}
                    required
                  />
              </div>
              {(this.state.internal_storage_tank === 0) &&
                <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AssociarManutencao}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.maintenance_association}
                    name="maintenance_association"
                    onChange={this.handleToggleChange.bind(this, 'maintenance_association')}
                  />
                </div>
              }
            </div>
          :
              <div>
                <div className="col-md-4 form-group">
                    <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Relatorio}:</label>
                    <Select
                        className="form-field-name"
                        name="flight_report_id"
                        value={this.state.flight_report_id}
                        searchable={true}
                        placeholder={'Selecione'}
                        onChange={this.handleSelectChangeReport.bind(this, 'flight_report_id')}
                        options={this.state.flight_reports_select}
                        required
                    />
                </div>
                <div className="col-md-4 form-group">
                    <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Trecho}:</label>
                    <Select
                        className="form-field-name"
                        name="flight_report_leg_id"
                        value={this.state.flight_report_leg_id}
                        searchable={true}
                        placeholder={'Selecione'}
                        onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
                        options={this.state.flight_report_legs_select}
                        required
                    />
                </div>
                <div className="col-md-4 form-group">
                    <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade}:</label>
                    <Select
                      className="form-field-name"
                      name="location_id"
                      value={this.state.location_id}
                      searchable={true}
                      placeholder={'Selecione'}
                      onChange={this.handleSelectChange.bind(this, 'location_id')}
                      options={this.state.locations_select}
                      required
                    />
                </div>
              </div>
      }
    </div>
    {this.formFields(this.state.export_required)}
  </form>
</div>
    );
  }
}

export default FlightReportRefuelRequestEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/Elements/FlightReportRefuelRequestEditTab.js